module.exports = __webpack_public_path__ + "5f9a909d1a01ddbbb3f75fc249da5abc.svg";